// src/Components/Apiurs/Apiurls.js
// const baseURL = "http://localhost:5000";
const baseURL = "https://crm.sbsgroups.co.in:8080";

export const defaultManagerId = 88;

// 👇 Add this line
export default baseURL;
